import React from "react";

import ReuseableButton from "../../../components/Buttons/button";
import { DataGrid } from '@mui/x-data-grid';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import useInsuranceTableHook from "./insuranceTableHook";
import { userColumns } from "./insuranceColumns";

const InsuranceTable = () => {
    const { 
        insuranceState,
        handleGetRowId,
        handleDelete,
        handleInsurance,
        loader
     } = useInsuranceTableHook()
    const actionColumn = [
        {
            field: "action",
            headerName: "Action",
            width: 200,
            renderCell: (params) => {
                return (
                    <div className="cellAction">
                        <div
                            className="deleteButton"
                            onClick={(e) => handleDelete(e, params.row)}
                        >
                            Delete
                        </div>
                    </div>
                );
            },
        },
    ];

    return (
        <>
            <div className='d-flex justify-content-end'>
                <div className="mr-5">
                    <ReuseableButton
                        text={"Add Insurance"}
                        height={45}
                        colorVarient="success"
                        fullWidthFlag={true}
                        endIcon={<PersonAddAltIcon />}
                        handleChange={handleInsurance}
                    />

                </div>
            </div>
            <div className="branch-table p-2">
                <DataGrid
                    autoHeight
                    rows={insuranceState && insuranceState?.length > 0 ? insuranceState : []}
                    loading={loader ? loader : false}
                    columns={userColumns.concat(actionColumn)}
                    pageSize={10}
                    rowsPerPageOptions={[5]}
                    disableSelectionOnClick
                    experimentalFeatures={{ newEditingApi: true }}
                    getRowId={handleGetRowId}
                    checkboxSelection={false}
                />
            </div>
        </>
    );
};

export default InsuranceTable;